module.exports = __webpack_public_path__ + "img/heightlight-bg.64811df5.png";